var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49695 10.9989H12.6674",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1664 8.5L12.6674 11.001L10.1664 13.5021",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99792 8.6115V7.1634C5.9984 6.3689 6.5594 5.6851 7.33848 5.52938L16.509 3.52355C17.0208 3.46442 17.5332 3.62882 17.9152 3.97464C18.2971 4.32047 18.5113 4.81415 18.5031 5.3293V16.8341C18.5034 17.3259 18.2865 17.7927 17.9105 18.1096C17.5345 18.4266 17.0378 18.5615 16.5532 18.4781L7.38267 16.9008C6.58231 16.7631 5.99754 16.0689 5.99792 15.2568V13.4752",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ab74e90c1169e0d5a50dcd9881fee363.svg";
export { ForwardRef as ReactComponent };